module.exports = __webpack_public_path__ + "static/img/aaa.75a8b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aaa.jpg
// module id = Yb0W
// module chunks = 5